<template>
  <div
    class="h-screen flex overflow-hidden bg-gray-200"
    :class="{ 'bg-indigo-600': error }"
    id="mainLayout"
  >
    <before-session-expire
      :is-display-expiration-session-popup="isDisplayExpirationSessionPopup"
      @close="isDisplayExpirationSessionPopup = false"
    />
    <cgv-popup :data-to-show="waitToCGV" />
    <cgu-popup
      :data-to-show="waitToCGU"
      @accepted="(e) => startOnboarding(e)"
    />
    <onboarding
      v-if="false"
      :current-page="currentPage"
      ref="onboarding"
    />

    <onboarding2
      v-if="$freeParticulier()"
      v-show="!$isMobile()"
      ref="onboardingv2"
    />

    <!-- Loading modal -->
    <transition leave-active-class="duration-200">
      <div
        v-show="loading"
        class="flex items-center z-50 fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
      >
        <!-- Background modal -->
        <transition
          enter-active-class="ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="loading"
            class="fixed inset-0 transition-opacity"
          >
            <div
              class="absolute inset-0 bg-indigo-600 bg-opacity-85 flex items-center justify-center"
            >
              <!-- Content modal  -->
              <div>
                <span class="flex justify-center spinner" />
                <br>
                <transition
                  enter-active-class="ease-out duration-1000"
                  enter-class="opacity-0"
                  enter-to-class="opacity-100"
                  leave-active-class="ease-in duration-200"
                  leave-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <!-- This message don't appear when we want. We have to upgrade this before display it -->
                  <div
                    v-show="msgLongLoading"
                    class="text-center text-base text-white animate-pulse"
                  >
                    <p>Les données sont en cours de chargement.</p>
                    <p>Cela peut-être long...Veuillez patienter.</p>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </transition>
        <!-- FIN Background modal -->
      </div>
    </transition>
    <!-- END Loading modal -->

    <!-- Off-canvas menu for mobile -->
    <menu-mobile
      class="xl:hidden"
      :is-open="showMenu"
      @close="showMenu = false"
      :has-menu-neopass-form="menuNeopassForm"
      :has-menu-cartographie-collective="menuCartographieCollective"
      :has-menu-templates="menuTemplates"
      :has-menu-cartographie-individuelle="menuCartographieIndividuelle"
      :has-menu-curriculum-vitae="menuCvForm"
    />

    <!-- Static sidebar for desktop -->
    <menu-desktop
      class="hidden xl:block"
      v-if="!error && !$isGuest()"
    />

    <menu-formulaire
      class="hidden xl:block"
      v-if="menuNeopassForm"
      id="tour_menu_neopass"
    />

    <menu-page-template
      class="hidden xl:block"
      v-if="menuTemplates"
    />

    <menu-cartographie-collective
      class="hidden xl:block"
      v-if="menuCartographieCollective"
    />
    <menu-cartographie-Individuelle
      class="hidden xl:block"
      v-if="menuCartographieIndividuelle"
    />

    <menu-cv-formulaire
      class="hidden xl:block"
      v-if="menuCvForm"
    />

    <menu-help v-if="menuHelp" />

    <div
      v-show="!waitToCGV && !waitToCGU"
      class="flex flex-col w-0 flex-1 overflow-hidden"
    >
      <navbar
        class="z-10"
        @open="showMenu = true"
        v-if="!error"
      />

      <div
        id="main-content"
        class="flex-1 relative overflow-y-auto lg:px-6 focus:outline-none md:py-6"
        tabindex="0"
      >
        <div class="lg:pl-4 py-4 px-6 lg:px-10">
          <!-- Contenu -->
          <router-view id="main-router-view" />
          <!-- Fin Contenu -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import axios from '../../api';
import store from '../../store';
import Constants from './../../constants';

import MenuDesktop from '../../components/MenuDesktop';
import MenuMobile from '../../components/MenuMobile';
import Navbar from '../../components/Navbar';
import MenuFormulaire from '../../components/MenuFormulaire';
import MenuCvFormulaire from '../../components/MenuCvFormulaire';
import MenuPageTemplate from '../../components/MenuPageTemplate';
import MenuCartographieCollective from '../../components/MenuCartographieCollective';
import MenuCartographieIndividuelle from '../../components/MenuCartographieIndividuelle';
import Icon from '../../components/Icon';
import MenuHelp from '../../components/MenuHelp';
import Popup from '../../components/Popup';
import ActionButton from '../../components/ActionButton';

import BeforeSessionExpire from '../../components/Login/BeforeSessionExpire.vue';
import CgvPopup from './../../components/Login/CGVPopup.vue';
import CguPopup from './../../components/Login/CGUPopup.vue';

import Onboarding from '../../components/Onboarding/Onboarding-old.vue';

import Onboarding2 from '../../components/Onboarding/Onboarding.vue';

export default {
  components: {
    MenuHelp,
    MenuDesktop,
    MenuMobile,
    Navbar,
    MenuFormulaire,
    MenuCvFormulaire,
    MenuPageTemplate,
    MenuCartographieCollective,
    MenuCartographieIndividuelle,
    Icon,
    Popup,
    ActionButton,
    BeforeSessionExpire,
    CgvPopup,
    CguPopup,
    Onboarding,
    Onboarding2
  },

  name: 'MainLayout',

  data() {
    return {
      constants: Constants,
      isDisplayExpirationSessionPopup: false,
      showMenu: false,
    };
  },

  created: function () {
    //skip onboarding on popstate event
    /* window.addEventListener('popstate', (event) => {
                if (this.$refs.onboarding.ongoingTour === true){
                    this.$refs.onboarding.tourSkipped();
                }
            }) */
  },

  mounted: function () {
    this.launchOnboarding();

    setInterval(() => {
      this.SET_TIMEREXPIRATIONSESSION(this.timerExpirationSession + 1);
    }, 1000);

    axios.interceptors.response.use(
      function (response) {
        //Call was successful
        //Add timer to synchro with expiration session time.
        store.commit('auth/SET_TIMEREXPIRATIONSESSION', 0);

        return response;
      },

      function (error) {
        switch (error.response.status) {
        case 401: // Not logged in
        case 419: // Session expired
          //window.location.replace('/login/sessionExpired');
          break;
        case 503: // Down for maintenance
          // Bounce the user to the login screen with a redirect back
          window.location.reload();
          break;
        case 500:
          alert('Oops, something went wrong!  The team have been notified.');
          break;
        default:
          // Allow individual requests to handle other errors
          return Promise.reject(error);
        }
      }
    );
  },

  updated: function () {
    this.launchOnboarding();
  },

  methods: {
    ...mapMutations({
      SET_TIMEREXPIRATIONSESSION: 'auth/SET_TIMEREXPIRATIONSESSION',
    }),

    launchOnboarding() {
      //this.$refs.onboarding.launchOnboarding();
    },

    close() {
      this.showMenu = $event;
    },

    startOnboarding(CGUaccepted) {
      console.log('startOnboarding');
      if (!this.$freeParticulier()) {
        return;
      }
      if (this.$isMobile()) {
        return;
      }
      if (CGUaccepted) {
        this.$refs.onboardingv2.askToEnable();
      }
    }
  },

  computed: {
    ...mapGetters({
      loading: 'app/loading',
      msgLongLoading: 'app/msgLongLoading',
      user: 'auth/user',
      permissions: 'auth/permissions',
      role: 'auth/role',
      permissionsOnBeneficiariesNeopass:
        'auth/permissionsOnBeneficiariesNeopass',
      timerExpirationSession: 'auth/timerExpirationSession',
    }),

    currentPage() {
      return this.$route.path;
    },

    menuNeopassForm() {
      return this.currentPage.includes('/form/neopass');
    },

    menuCartographieCollective() {
      return this.currentPage.includes('cartographies/collectives');
    },

    menuCartographieIndividuelle() {
      return this.currentPage.includes('cartographies/individuelles');
    },

    menuTemplates() {
      return this.currentPage.includes('modeles-de-page');
    },

    menuCvForm() {
      return this.currentPage.includes('/curriculumvitae/form');
    },

    menuHelp() {
      //  return this.currentPage.includes("/aide");
      return false;
    },

    error() {
      return this.currentPage.includes('/notFound');
    },

    waitToCGV() {
      return (
        this.role === Constants.ROLE_ADMIN_PAYEUR &&
        this.user.CGV_accepted === null
      );
    },

    waitToCGU() {
      const is_beneficiary = this.role === Constants.ROLE_BENEFICIAIRE;
      const is_particulier = this.$freeParticulier();
      const has_accepted_cgu = this.user.CGU_accepted !== null;

      if (has_accepted_cgu) return false;
      return is_beneficiary || is_particulier;
    },
  },

  watch: {
    timerExpirationSession: {
      handler() {
        if (
          this.timerExpirationSession ===
          process.env.MIX_SESSION_LIFETIME * 60 - 900
        ) {
          this.isDisplayExpirationSessionPopup = true;
        }
        if (
          this.timerExpirationSession >
          process.env.MIX_SESSION_LIFETIME * 60
        ) {
          //Reload page when session expired
          window.location.replace('/login/sessionExpired');
        }
      },
    },
  },
};
</script>
